import {
    LOAD_TEMPLATE_DETAIL,
    LOAD_TEMPLATE_DETAIL_SUCCESS,
    LOAD_TEMPLATE_DETAIL_ERROR,
    LOAD_SIMILAR_TEMPLATES,
    LOAD_SIMILAR_TEMPLATES_SUCCESS,
    LOAD_SIMILAR_TEMPLATES_ERROR,
  } from './constants';
  
  export const initialState = {
    templateDetail: {},
    similarTemplates: [],
    isLoadingTemplateDetail: false,
    isLoadingSimilarTemplates: false,
  };
  
  function templatePreviewReducer(state = initialState, action) {
    switch (action.type) {
    case LOAD_TEMPLATE_DETAIL:
      return {
        ...state,
        isLoadingTemplateDetail: true,
      };
    case LOAD_TEMPLATE_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingTemplateDetail: false,
        templateDetail: state.templateDetail,
      };
    case LOAD_TEMPLATE_DETAIL_ERROR:
      return {
        ...state,
        isLoadingTemplates: false,
      };

    case LOAD_SIMILAR_TEMPLATES:
        return {
            ...state,
            isLoadingSimilarTemplates: true,
        };
    case LOAD_SIMILAR_TEMPLATES_SUCCESS:
        return {
            ...state,
            isLoadingSimilarTemplates: false,
            similarTemplates: state.similarTemplates,
        };
    case LOAD_SIMILAR_TEMPLATES_ERROR:
        return {
            ...state,
            isLoadingSimilarTemplates: false,
        };

    default:
      return state;
    }
  }
  
  export default templatePreviewReducer;
  